var resources = require('items-view-strings');
    var strings = resources['_/zyhlnSD2g+yrAtM7XDZmw'];
export { strings };
export default strings;
